import type { SignupAuth } from './activation';

export type SampleFeature = 'conversations' | 'team' | 'campaigns' | 'contacts' | 'reminders';

/** Example content belongs to the view only: never a customer, message, or job record. */
export function canShowSignupSamples(auth: (SignupAuth & { reseller?: unknown }) | null | undefined): boolean {
  const marker = auth?.selfServeSignup;
  return !!auth?._id && !!auth?.user?._id && !auth.reseller && marker?.version === 1
    && !!marker.emailVerifiedAt && Number.isFinite(Date.parse(marker.emailVerifiedAt))
    && ['pending_activation', 'cancelled', 'active'].includes(marker.status || '');
}

export function samplePreferenceKey(auth: SignupAuth, feature: SampleFeature): string {
  return `chekkit:signup-examples:v1:${auth._id}:${auth.user?._id}:${feature}`;
}

export function shouldShowSampleFeature({ eligible, ready, realCount, hidden }: {
  eligible: boolean; ready: boolean; realCount: number; hidden: boolean;
}): boolean {
  return eligible && ready && Number.isFinite(realCount) && realCount === 0 && !hidden;
}

// Deliberately display-only: no recipient IDs, phone/email fields, transport,
// scheduling timestamps, or model-shaped objects that sending code could use.
export const sampleRows: Record<SampleFeature, ReadonlyArray<{ title: string; detail: string; label: string }>> = {
  conversations: [
    { title: 'Jamie Ellis', detail: 'Thanks! Thursday works perfectly.', label: 'Appointment confirmed' },
    { title: 'Morgan Lee', detail: 'Could you tell me a little more?', label: 'New enquiry' },
  ],
  team: [
    { title: 'Morning handoff', detail: 'Alex: I’ll take care of Jamie’s appointment.', label: 'Team group' },
    { title: 'Alex Morgan', detail: 'Thanks for keeping me in the loop!', label: 'Direct message' },
  ],
  campaigns: [
    { title: 'A friendly seasonal check-in', detail: 'Reach a group of customers with one personal message.', label: 'Example draft' },
  ],
  contacts: [
    { title: 'Jamie Ellis', detail: '(204) 555-0101 · jamie@example.com', label: 'New customer' },
    { title: 'Morgan Lee', detail: '(204) 555-0102 · morgan@example.com', label: 'Returning customer' },
  ],
  reminders: [
    { title: 'Follow up on Jamie’s quote', detail: 'Tomorrow · Assigned to you', label: 'To do' },
  ],
};
